import React from "react";
import CustomCard from "../../../shared/Card/CustomCard";
import TrackForm from "./TrackForm";

export default function ViewTrack({ name }) {
  return (
    <CustomCard title={name}>
      <TrackForm type="VIEW" />
    </CustomCard>
  );
}
